import { BACKEND_ROUTES } from "../../backendRoutes";
import { useParams } from "react-router-dom";
import useSWR from "swr";

export const useSite = () => {
    const { siteUuid } = useParams();

    return useSWR(`${BACKEND_ROUTES.SITE}/${siteUuid}?parentInfo=true`);
};
